import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '../../styles/Pagination.module.css';

const Pagination = ({ totalGames, gamesPerPage, currentPage }) => {
  const router = useRouter();
  const totalPages = Math.ceil(totalGames / gamesPerPage);
  
  const handleSmoothScroll = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div className={styles.pagination}>
        <div className={styles.pagination_text}>Pages:</div>
        {[...Array(totalPages)].map((_, index) => {
          const pageNum = index + 1;
          const href = {
            pathname: router.pathname,
            query: { ...router.query, page: pageNum },
          };

          return (
            <Link key={index} href={href} passHref scroll={false}>
              <a
                onClick={handleSmoothScroll}
                className={currentPage === pageNum ? styles.active : ''}
              >
                {pageNum}
              </a>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default Pagination;
